export const THEME_STORAGE_KEY = "theme";

export const getPreferredTheme = () => {
  if (typeof window === "undefined") return "light";
  return window.matchMedia?.("(prefers-color-scheme: dark)")?.matches ? "dark" : "light";
};

export const getStoredTheme = () => {
  if (typeof window === "undefined") return "light";

  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
  return storedTheme === "light" || storedTheme === "dark"
    ? storedTheme
    : getPreferredTheme();
};

export const applyThemeToDocument = (nextTheme) => {
  const resolvedTheme = nextTheme === "dark" ? "dark" : "light";

  if (typeof document === "undefined") {
    return resolvedTheme;
  }

  const root = document.documentElement;
  root.dataset.theme = resolvedTheme;
  root.classList.toggle("dark", resolvedTheme === "dark");

  if (document.body) {
    document.body.dataset.theme = resolvedTheme;
    document.body.classList.toggle("dark", resolvedTheme === "dark");
  }

  return resolvedTheme;
};